import UserProfile from './../../common/user/profile';

export default function(data) {
  UserProfile.init();

  var self = this;
  self.$el = $('#user_profile');
  self.$socialPopover = $('#js-social-unit-menu');
  self.$socialHolder = $('#js-social-edit-holder');
  self.$socialAddBtn = $('#js-social-unit-add');

  self.employmentStatuses = ko.observableArray(['Full-Time', 'Part-Time', 'Self-Employed', 'Unemployed', 'Retired', 'Other']);
  self.employmentIndustries = ko.observable(['Accounting','Airlines/Aviation','Alternative Dispute Resolution','Alternative Medicine','Animation','Apparel and Fashion','Architecture and Planning','Arts and Crafts','Automotive','Aviation and Aerospace','Biotechnology','Broadcast Media','Building Materials','Business Supplies and Equipment','Capital Markets','Chemicals','Civic and Social Organization','Civil Engineering','Commercial Real Estate','Computer and Network Security','Computer Games','Computer Hardware','Computer Networking','Computer Software','Construction','Consumer Electronics','Consumer Goods','Consumer Services','Cosmetics','Dairy','Defense and Space','Design','E-learning','Electrical and Electronic Manufacturing','Entertainment','Environmental Services','Events Services','Executive Office','Facilities Services','Farming','Financial Services','Fine Art','Fishery','Food and Beverages','Food Production','Fundraising','Furniture','Gambling and Casinos','Glass, Ceramics and Concrete','Government Administration','Government Relations','Graphic Design','Health, Wellness and Fitness','Higher Education','Hospital and Health Care','Hospitality','Human Resources','Import and Export','Individual and Family Services','Industrial Automation','Information Services','Information Technology and Services','Insurance','International Affairs','International Trade and Development','Internet','Investment Banking','Investment Management','Judiciary','Law Enforcement','Law Practice','Legal Services','Legislative Office','Leisure and Travel','Libraries','Logistics and Supply Chain','Luxury Goods and Jewelry','Machinery','Management Consulting','Maritime','Market Research','Media Production','Medical Device','Medical Practice','Mental Health Care','Military','Mining and Metals','Motion Pictures and Film','Museums and Institutions','Music','Nanotechnology','Newspapers','Oil and Energy','Online Publishing','Outsourcing/Offshoring','Package/Freight Delivery','Packaging and Containers','Paper and Forest Products','Performing Arts','Pharmaceuticals','Philanthropy','Photography','Plastics','Political Organization','Primary/Secondary','Printing','Professional Training','Program Development','Public Policy','Public Relations','Public Safety','Publishing','Railroad Manufacture','Ranching','Real Estate','Recreational Facilities and Services','Religious Institutions','Renewables and Environment','Research','Restaurants','Retail','Security and Investigations','Semiconductors','Shipbuilding','Sporting Goods','Sports','Staffing and Recruiting','Supermarkets','Telecommunications','Textiles','Think Tanks','Tobacco','Translation and Localization','Transportation/Trucking/Railroad','Utilities','Venture Capital','Veterinary','Warehousing','Wholesale','Wine and Spirits','Wireless','Writing and Editing','Enterprise Software','Retail Banking','Strategy Consulting','IT Consulting','Technology','Startups','Tourism','Travel','Marketing','Health Care','Advertising','Education Services','Nonprofits','Dentistry','Medicine','Mechanical Engineering','Industrial Engineering','Surgery','Risk Management','Medical Practice Professional', 'Other']);
  self.educationDegrees = ko.observableArray(['Less than high school graduate','High school graduate','Some college','Associate degree','Bachelor\'s degree','Master\'s degree','Doctorate degree']);
  self.educationStatuses = ko.observableArray(['Freshman','Sophomore','Junior','Senior','Graduated','Unenrolled','Other']);
  self.genders = ko.observableArray(['Male', 'Female', 'Trans Man', 'Trans Woman', 'Gender Queer', 'No Binary', 'Other']);
  self.states = ko.observableArray([]);
  self.countries = ko.observableArray([]);

  self.saving = ko.observable(false);

  self.portfolio_projects = ko.observableArray([]);
  self.profile = ko.observable();

  self.fetchLocationData = function(params) {
    $.getJSON(Kadenze.Routes.locations_path(params)).pipe(function (data, status, jqXHR) {
      self.countries(data.countries);
      self.states(data.states);
    });
  };

  self.bindData = function(data, countries, states) {
    self.countries(countries);
    self.states(states);
    var autosaveProps = ['gender', 'other_gender', 'date_of_birth_string', 'city', 'state', 'country', 'languages_spoken',
      'education_school', 'education_major', 'education_degree', 'education_status',
      'employment_employer', 'employment_industry', 'employment_status', 'bio'];

    var mapped = ko.mapping.fromJS(data);
    self.profile(mapped.profile);

    // autosave the object when any property changes
    var _subscribeToProps = function(key, obj, parent) {
      if (ko.isObservable(obj)) {
        obj.subscribe(function(newVal) {
          self.save();
        });
      }
    };

    setTimeout(function() {
      for (var prop in self.profile()) {
        if (_.contains(autosaveProps, prop)) {
          var obj = self.profile()[prop];
          _subscribeToProps(prop, obj);
        }
      }

      for (var prop in self.profile().address) {
        if (_.contains(autosaveProps, prop)) {
          var obj = self.profile().address[prop];
          _subscribeToProps(prop, obj, 'address');
        }
      }
    }, 1000);

    // Note: redactor elements have to be handles differently for autosave because
    // they fire change events on keydown (or something similar). Too many requests that way.
    self.profile().bio.extend({
      rateLimit: { timeout: 1000, method: 'notifyWhenChangesStop' },
      required: false
    });

    self.initUI();
  };

  self.formattedAddress = ko.computed(function() {
    if (!self.profile || !self.profile()) {
      return '';
    }
    var parts = [self.profile().address.city(), self.profile().address.state(), self.profile().address.country()];
    parts = parts.filter(function(item, idx) {
      return item && item.trim() != '';
    });

    return parts.join(', ');
  });

  self.formattedDob = ko.computed(function() {
    if (!self.profile || !self.profile() || !self.profile().date_of_birth_string) {
      return '';
    }
    var dob_str = self.profile().date_of_birth_string();
    if (!dob_str || dob_str.trim() == '') {
      return '';
    }
    return moment(self.profile().date_of_birth_string()).format(Kadenze.I18n.t('date.formats.js_default'));
  });

  self.initStateCountrySelect = function() {
    var _callback = function (data, status, jqXHR) {
      self.countries(data.countries);
      self.states(data.states);
    };

    self.profile().address.country.subscribe(function(country) {
      $(document).click(); //Hack to get selectpicker to hide
      self.fetchLocationData({country: country}, _callback);
    });

    self.profile().address.state.subscribe(function(state) {
      $(document).click(); //Hack to get selectpicker to hide
    });
  };

  self.initGenderSelect = function() {
    self.profile().gender.subscribe(function(gender) {
      if(gender != 'Other') {
        self.profile().other_gender('');
      }
    });
  };

  self.initTagInputs = function() {
    $('.js-tagsinput').tagsinput({
      confirmKeys: [9, 13, 188],
      trimValue: true,
      allowDuplicates: false
    });
  };

  self.initUI = function() {
    self.initStateCountrySelect();
    self.initGenderSelect();
  };

  self.validate = function() {
    self.client_errors = ko.validation.group(self.profile(), { deep: true });

    if(self.client_errors().length > 0) {
      self.client_errors.showAllMessages();

      return false;
    } else {
      return true;
    }
  };

  self.save = function(data) {
    var mapping = {
      include: ['remove_avatar']
    };

    if (data) {
      // saving partial data, massage it if necessary
      data = data.user ? data : { user: data };
    } else {
      // save all data
      data = {user: ko.mapping.toJS(self.profile, mapping)};
      delete data.user.social_info;

    }
    if (data.user.address) {
      data.user.address_attributes = data.user.address;
      delete data.user.address;
    }

    self.client_errors = ko.validation.group(self.profile(), { deep: true });

    // convert undefined values to null so they are passed to the server
    data.user = Kadenze.Util.convertUndefinedToNull(data.user, null, true);

    if (self.validate()) {
      // if (self.client_errors().length === 0) {
      var request = new Kadenze.AjaxRequest({
        type: 'PUT',
        url: Kadenze.Routes.users_path(),
        data: data
      });

      request.done(function(response) {
        self.profile().no_info(false);
        new Kadenze.Notice.success({message: response.message });
      });

      request.fail(function(xhr, status, msg) {
        if (xhr.responseJSON) {
          msg = xhr.responseJSON.message;
        }
        new Kadenze.Notice.error({message: msg});
      });

    } else {
      self.client_errors.showAllMessages();
    }
  };

  self.openSocialMenu = function() {
    TweenLite.to(self.$socialPopover, 0.25, {autoAlpha: 1});
  };

  self.closeSocialMenu = function() {
    TweenLite.to(self.$socialPopover, 0.25, {autoAlpha: 0});
  };

  self.addSocialLink = function(item, event) {
    var $input = $('#js-social-input-'+ item.id);
    var $parent = $input.parent();
    var $delBtn = $parent.find('.js-social-unit-delete');

    // for setting right position of btn on start of animation
    var unitWidth = self.$socialHolder.width() - $delBtn.width();
    // get color of add btn
    var addColor = self.$socialAddBtn.css('background-color');
    var $minus = $delBtn.find('.icon-circle-minus-minus');

    var speed = 0.6;

    TweenLite.set(self.$socialAddBtn, {autoAlpha:0});

    var timeline = new TimelineLite({
      onComplete:function(){
        TweenLite.to(self.$socialAddBtn, 0.3, {autoAlpha:1});
      }
    }).pause();

    timeline.insert(TweenLite.set($parent, { autoAlpha:1 }));
    timeline.insert(TweenLite.from($input, speed, { width:0, paddingRight:0, ease:Power2.easeOut }));
    timeline.insert(TweenLite.from($delBtn, speed, { right: unitWidth, backgroundColor:addColor, ease:Power2.easeOut  }));
    timeline.insert(TweenLite.from($minus, (speed/2), { opacity:0, delay: (speed/2) }));
    timeline.play();

    self.profile().social_info[item.id](item.value);

    self.closeSocialMenu();
  };

  self.deleteSocialLink = function(item, event) {
    var $el = $(event.currentTarget);
    var $parent = $el.parent();
    var $input = $parent.find('.user-profile__social-edit_input');

    TweenLite.to($parent, 0.25, {
      autoAlpha: 0,
      onComplete: function(){
        $input.val('').change();
      }
    });
  };

  const __construct = function(that) {
    console.log('constructor called for UserProfileInfoViewModel');
    var countries = JSON.parse($('#countries_json').val());
    var states = JSON.parse($('#states_json').val());
    that.bindData(data, countries, states);
  }(this);
}
